<template>
    <div class="goodList">
        <Form
                ref="formValidate"
                :model="formValidate"
                :label-width="labelWidth"
                :label-position="labelPosition"
                class="tabform">
            <Row type="flex" :gutter="24">
                <Col v-bind="grid">
                    <FormItem label="分销商姓名：" label-for="order_no">
                        <Input size="default" enter-button placeholder="分销商姓名" clearable v-model="formValidate.real_name"/>
                    </FormItem>
                </Col>
                <Col v-bind="grid">
                    <FormItem label="分销商手机号：" label-for="mobile">
                        <Input size="default" enter-button placeholder="分销商手机号" clearable v-model="formValidate.mobile"/>
                    </FormItem>
                </Col>

                <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24" class="search">
                    <FormItem>
                        <Button type="primary" icon="ios-search" @click="userSearchs">搜索</Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <Table
                ref="table"
                no-data-text="暂无数据"
                no-filtered-data-text="暂无筛选结果"
                max-height="400"
                :columns="columns"
                :data="tableList"
                :loading="loading">
            <template slot-scope="{ row, index }" slot="avatars">
                <viewer>
                    <div class="tabBox_img">
                        <img :src="row.user.avatar" />
                    </div>
                </viewer>
            </template>
            <template slot-scope="{ row, index }" slot="referee">
                <div class="">{{row.referee_id ? row.referee.real_name : ''}}</div>
                <div class="">{{row.referee_id ? row.referee.mobile : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="level">
                <div class="">{{row.level ? row.level.name : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="money_rate">
                <div class="">一级：{{row.level ? row.level.first_money : ''}}</div>
                <div class="">二级：{{row.level ? row.level.second_money : ''}}</div>
                <div class="">三级：{{row.level ? row.level.third_money : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="first_money">
                <div class="">{{row.level ? row.level.first_money : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="second_money">
                <div class="">{{row.level ? row.level.second_money : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="third_money">
                <div class="">{{row.level ? row.level.third_money : ''}}</div>
            </template>
            <template slot-scope="{ row, index }" slot="first_child_num">
                <router-link :to="{path: '/Member/MemberList.html', query: {referee_id: row.user_id}}" class="">{{row.first_child_num}}</router-link>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <el-button size="mini" type="primary" class="ml10" @click="select(row)">选择</el-button>
            </template>
        </Table>
        <div class="acea-row row-right page">
            <Page
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                    :page-size="formValidate.pagesize"/>
        </div>
        <div class="footer" slot="footer" v-if="many === 'many' && !diy">
            <Button
                    type="primary"
                    size="large"
                    :loading="modal_loading"
                    long
                    @click="ok">提交
            </Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            is_new: {
                type: String,
                default: "",
            },
            diy: {
                type: Boolean,
                default: false,
            },
            isdiy: {
                type: Boolean,
                default: false,
            },
            ischeckbox: {
                type: Boolean,
                default: false,
            },
            liveStatus: {
                type: Boolean,
                default: false,
            },
            isLive: {
                type: Boolean,
                default: false,
            },
            datas: {
                type: Object,
                default: function () {
                    return {};
                },
            },
        },
        data() {
            return {
                modal_loading: false,
                treeSelect: [],
                formValidate: {
                    page: 1,
                    pagesize: 15,
                    store_category_id: "",
                    name: "",
                    is_new: this.is_new,
                },
                total: 0,
                modals: false,
                loading: false,
                grid: {
                    xl: 10,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                tableList: [],
                currentid: 0,
                goodsRow: {},
                columns: [
                    {
                        title: 'ID',
                        key: 'user_id',
                        width: 60,
                    },
                    {
                        title: "头像",
                        slot: "avatars",
                        width: 60,
                    },
                    {
                        title: "真实姓名",
                        key: "real_name",
                        minWidth: 120,
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: 150,
                    },
                    {
                        title: '分销等级',
                        slot: 'level',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: "center",
                        width: 100,
                    },
                ],
                images: [],
                diyVal: [],
                many: "",
            };
        },
        computed: {
            labelWidth() {
                return 120;
            },
            labelPosition() {
                return "right";
            },
        },
        created() {
            let radio = {
                width: 60,
                align: "center",
                render: (h, params) => {
                    let goods_id = params.row.goods_id;
                    let flag = false;
                    if (this.currentid === goods_id) {
                        flag = true;
                    } else {
                        flag = false;
                    }
                    let self = this;
                    return h("div", [
                        h("Radio", {
                            props: {
                                value: flag,
                            },
                            on: {
                                "on-change": () => {
                                    self.currentid = goods_id;
                                    this.goodsRow = params.row;
                                    this.$emit("getProductId", this.goodsRow);
                                    if (this.goodsRow.goods_id) {
                                        if (this.$route.query.fodder === "image") {
                                            /* eslint-disable */
                                            let imageObject = {
                                                goods_image: this.goodsRow.goods_image,
                                                goods_id: this.goodsRow.goods_id,
                                                name: this.goodsRow.name,
                                            };
                                            form_create_helper.set("image", imageObject);
                                            form_create_helper.close("image");
                                        }
                                    } else {
                                        this.$Message.warning("请先选择商品");
                                    }
                                },
                            },
                        }),
                    ]);
                },
            };

            let checkbox = {
                type: "selection",
                width: 60,
                align: "center",
            };
            let many = "";
            if (this.ischeckbox) {
                many = "many";
            } else {
                many = this.$route.query.type;
            }
            this.many = many;

        },
        mounted() {
            this.getList();
        },
        methods: {
            pageChange(index) {
                this.formValidate.page = index;
                this.getList();
            },
            // 列表
            getList() {
                this.loading = true;
                if (!this.liveStatus) {
                    if (this.isLive) {
                        this.formValidate.is_live = 1;
                    }
                    this.axios.post('/store/app.dealer.user/list', this.formValidate)
                        .then(async (res) => {
                            this.loading = false;
                            if (res.code == 1) {
                                let data = res.data.list
                                this.tableList = data.data;
                                this.total = data.total;
                            }
                        })
                        .catch((res) => {
                            this.loading = false;
                        });
                } else {
                }
            },
            // 表格搜索
            userSearchs() {
                this.formValidate.page = 1;
                this.getList();
            },
            clear() {
                this.goodsRow.id = "";
                this.currentid = "";
            },
            select: function (row) {
                this.$emit("getUser", row);
            }
        },
    };
</script>

<style scoped lang="less">
    .footer {
        margin: 15px 0;
    }

    .tabBox_img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .tabform {
        .ivu-form-item {
            margin-bottom: 16px !important;
        }
    }
    .btn {
        margin-top: 20px;
        float: right;
    }
    .goodList {
        table {
            width: 100% !important;
        }
    }
</style>
